// src/components/onboarding/StepCard.jsx
//
// One "Post Won Proposal Steps" card — shared by Step A (ContractsPanel) and
// Steps B–E (OnboardingPanel), so the five steps read as one list. Its own
// module because ContractsPanel's tests mock OnboardingPanel wholesale; a
// named export from there would vanish under the mock.
//
// Skipped is NOT done: muted italic text and a dash, never the green tick.
// Craig must be able to tell at a glance which steps actually created
// something in Autotask. The nothing-to-do tick is offered until the step is
// really done, flips in one click with no confirm, and a real run clears it.
import React from "react";

export const STEP_STATE_STYLE = {
  not_started: { bg: "#eef2f7", fg: "#475569", mark: "○", label: "Not started" },
  done:        { bg: "#dcfce7", fg: "#15803d", mark: "✓", label: "Done" },
  skipped:     { bg: "transparent", fg: "#94a3b8", mark: "–", label: "Marked nothing to do", border: "1px dashed #cbd5e1" },
  errors:      { bg: "#fee2e2", fg: "#b91c1c", mark: "!", label: "Errors" },
};

export function StepCard({ step, state, children, actions, onToggleSkip, busy, note }) {
  const s = STEP_STATE_STYLE[state.state] || STEP_STATE_STYLE.not_started;
  const skipped = state.state === "skipped";
  return (
    <div data-testid={`step-${step.id}`} data-state={state.state}
         style={{ border: "1px solid var(--border,#e2e8f0)", borderRadius: 8, padding: "10px 12px", marginTop: 8, background: "var(--s1,#fff)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: "0.06em", color: "var(--text3,#777)" }}>STAGE {step.letter}</span>
        <span style={{ fontSize: 12.5, fontWeight: 700 }}>{step.label}</span>
        <span data-testid={`step-${step.id}-state`} title={state.detail}
              style={{ fontSize: 9.5, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: s.bg, color: s.fg, border: s.border || "1px solid transparent",
                       textTransform: skipped ? "none" : "uppercase", letterSpacing: skipped ? 0 : ".06em", fontStyle: skipped ? "italic" : "normal" }}>
          {s.mark} {s.label}
        </span>
        {step.runsIn === "local" && (
          <span style={{ fontSize: 9.5, color: "var(--text3,#999)", fontStyle: "italic" }}>this app only — nothing goes to Autotask; run any time</span>
        )}
        <span style={{ marginLeft: "auto", display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>{actions}</span>
      </div>
      <div style={{ fontSize: 10.5, color: "var(--text3,#777)", marginTop: 3, lineHeight: 1.5 }}>{step.blurb}</div>
      {state.detail && <div data-testid={`step-${step.id}-detail`} style={{ fontSize: 11, color: "var(--text2,#555)", marginTop: 4 }}>{state.detail}</div>}
      {note}
      {state.errors && state.errors.length > 0 && (
        <div data-testid={`step-${step.id}-errors`} style={{ marginTop: 5 }}>
          {state.errors.map((e, i) => (
            <div key={i} style={{ fontSize: 10.5, color: "#c0392b", marginBottom: 2 }}>{e.message}</div>
          ))}
        </div>
      )}
      {children}
      {state.state !== "done" && state.state !== "errors" && onToggleSkip && (
        <label data-testid={`step-${step.id}-skip`} style={{ display: "inline-flex", gap: 6, alignItems: "center", fontSize: 10.5, color: "var(--text3,#777)", marginTop: 6, cursor: "pointer" }}>
          <input type="checkbox" checked={skipped} disabled={!!busy} onChange={onToggleSkip}
                 aria-label={`Nothing to do for Stage ${step.letter}`} />
          Nothing to do for this step
        </label>
      )}
    </div>
  );
}
